import { useMutation } from '@tanstack/react-query'
import { submitLeads } from "../api/post-leads"

export const useSubmitLeads = (options = {}) => {
  return useMutation({
    mutationFn: (params) => submitLeads(params),
    ...options
  })
}